"use strict";

import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Route, Router, Switch } from "react-router-dom";

import {
  builderIOInit,
  fbPixel,
  gtmDataLayerPush,
  identifyUser,
  posthogInit,
  posthogStartSessionRecording,
} from "../shared/utils/analytics";
import { bugsnagClient } from "../shared/utils/errorHandling";

import { ApolloClient, ApolloProvider, createHttpLink } from "@apollo/client";
import { InMemoryCache } from "@apollo/client/cache";
import { setContext } from "@apollo/client/link/context";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import theme from "../shared/styles/muiTheme.js";

// import "@stripe/stripe-js"; // https://github.com/stripe/stripe-js#ensuring-stripejs-is-available-everywhere - for fraud detection

import "../shared/styles/global-base.css";
import "../shared/styles/material-dashboard-overrides.css";

import indexRoutes from "./routes/index.js";


const httpLink = createHttpLink({
  uri: "/me/gql/graphql",
  credentials: "same-origin",
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

builderIOInit();

posthogInit();
identifyUser();
posthogStartSessionRecording();

const hist = createBrowserHistory();
hist.listen((location) => {
  // console.log("location:", location);

  // if (window.dataLayer) {
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     event: "Pageview",
  //     path: location.pathname
  //     // formLocation: "footer"
  //   });
  // }

  gtmDataLayerPush({
    event: "pageview",
    path: location.pathname,
  });

  fbPixel("PageView");

  // if (window.fbq) {
  //   window.fbq("track", "PageView");
  // }
});

const ErrorBoundary = bugsnagClient.getPlugin("react");

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <ApolloProvider client={apolloClient}>
          <Router history={hist}>
            <Switch>
              {indexRoutes.map((prop, key) => {
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          </Router>
        </ApolloProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </StyledEngineProvider>,
  document.getElementById("visits_container"),
);
